module.exports = __webpack_public_path__ + "static/media/18ec154c-b0b9-480c-992b-cb73be873e71_1.85be2744a33b26f53c6fd5982260602c.03c2e7d0.png";